import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders ,HttpParams} from '@angular/common/http';
import { environment } from "../../environments/environment"
@Injectable({
  providedIn: 'root'
})
export class PaymentContractService {




  constructor(private http : HttpClient) {}
  save(result:any) {
   
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/customer-payment-contract/save",result,{headers : headers,observe:"response"});
   }

   list(userId:any) {
    let header = new HttpHeaders();
    // let httpParam : HttpParams=new HttpParams();
      
  
      return this.http.get( environment.API_URL+"/api/customer-payment-contract/customer/"+userId ,{ observe : "body",responseType : "json"})  
  }
  
  payMode() {
    let header = new HttpHeaders();
    // let httpParam : HttpParams=new HttpParams();
      
  
      return this.http.get( environment.API_URL+"/api/customer-payment-contract/paymode" ,{ observe : "body",responseType : "json"})  
  }
  payChannel() {
    let header = new HttpHeaders();
    // let httpParam : HttpParams=new HttpParams();
      
  
      return this.http.get( environment.API_URL+"/api/customer-payment-contract/paychannel" ,{ observe : "body",responseType : "json"})  
  }
}
